import { useMemo } from 'react'

import { numberWithCommaWithoutDecimals } from '../../../utils'

import {
  MdOutlineBathtub,
  MdOutlineBed,
  MdOutlineFullscreen
} from 'react-icons/md'
import MonopolioImage from '../../MonopolioImage'
import { IPointPropertiesV2 } from '@wiggot/interfaces'

interface Props {
  property: IPointPropertiesV2
  onSelect?: (listing: IPointPropertiesV2) => void
}

const PROPERTY_TYPES: { [key: string]: string } = {
  house: 'Casa',
  apartment: 'Departamento',
  office: 'Oficina',
  consulting_room: 'Consultorio',
  warehouse: 'Bodega',
  industrial_building: 'Nave industrial',
  shop: 'Local',
  shop_shopping_center: 'Local en centro comercial',
  terrain: 'Terreno',
  ranch: 'Rancho',
  building: 'Edificio',
  hotel: 'Hotel',
  event_hall: 'Salón de eventos',
  cottage: 'Cabaña',
  other: 'Otro'
}

const PropertyItem = ({
  property,
  onSelect = () => null
}: Props): JSX.Element => {
  // const { isVisible, observedElementRef, disconnect } =
  //   useIntersectionObserverV2<HTMLDivElement>({
  //     threshold: 0
  //   })

  const propertyType = useMemo(() => {
    const propertyType = PROPERTY_TYPES[property?.propertyType]
    if (propertyType) {
      return propertyType
    }
    return 'unknown'
  }, [property])

  // useEffect(() => {
  //   if (isVisible) {
  //     loadImage()
  //   }
  // }, [isVisible])

  // useEffect(() => {
  //   return () => {
  //     disconnect()
  //   }
  // }, [])

  return (
    <div
      onClick={() => onSelect(property)}
      className="rounded-[20px] overflow-hidden h-[120px] grid grid-cols-[150px,auto] md:grid-cols-[169px,auto] gap-4 border border-surface-gray-20 cursor-pointer"
    >
      <div className="w-[150px] md:w-[169px] h-full relative bg-gray-100">
        <MonopolioImage
          src={property?.media[0]?.url}
          origin="twicpics"
          mode="cover"
          ratio="16/12"
        />
        <div className="absolute !bg-[#CCDDFD] bottom-[16px] left-[16px] px-2 h-[22px] flex items-center rounded-full">
          <p className="text-body-xs text-link">{propertyType}</p>
        </div>
      </div>

      <div className="flex flex-col gap-3 py-4 pr-4">
        <div className="text-black flex items-center gap-1">
          <p className="text-body-xxl font-bold">$</p>
          <p className="text-headline-xxs font-bold">
            {numberWithCommaWithoutDecimals(
              property?.priceAmount?.toString() || ''
            )}
          </p>
          <p className="text-body-m font-normal text-tertiary-input">MXN</p>
        </div>

        <div className="w-full grid">
          <p className="text-body-s text-black truncate">{property?.address}</p>
        </div>

        <div className="flex items-center justify-start w-full gap-2">
          {property?.constructionSurface > 0 && (
            <div className="px-[.375rem] text-secondary text-[10px] font-medium gap-[.25rem] rounded-[25px] w-max items-center flex">
              {`${property.constructionSurface} m²`}
              <MdOutlineFullscreen className="w-[18px] h-[18px] fill-secondary" />
            </div>
          )}

          {property?.bedrooms > 0 && (
            <div className="px-[.375rem] text-secondary text-[10px] font-medium gap-[.25rem] rounded-[25px] w-max items-center flex">
              {property.bedrooms}

              <MdOutlineBed className="w-[18px] h-[18px] fill-secondary" />
            </div>
          )}

          {property?.bathrooms > 0 && (
            <div className="px-[.375rem] text-secondary text-[10px] font-medium gap-[.25rem] rounded-[25px] w-max items-center flex">
              {property.bathrooms}
              <MdOutlineBathtub className="w-[18px] h-[18px] fill-secondary" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PropertyItem
